
import _ from 'lodash';
import Cookies from 'js-cookie';
const packageConfig = require("../../../package.json");
let staticVersion = packageConfig.version;

// 延迟函数
export const delay = (duration = 1000) => {
  return new Promise(resolve => {
    setTimeout(resolve, duration)
  })
}
// 延迟执行函数
export const sleep = (duration = 1000, callback) => {
  _.delay(function(text) {
    console.log(text);
    callback && callback()
  }, duration, 'later');
}

// 休眠函数
export const sleepSync = (duration = 1000) => {
  const start = new Date().getTime();
  console.log('休眠前：' + start)
  while (true) {
    if (new Date().getTime() - start > duration) {
      break;
    }
  }
  console.log('休眠后：' + new Date().getTime());
}

export function trim(x) {
  return (x.trim && x.trim()) || (x.replace(/^\s+|\s+$/gm,''));
}
// trim函数
export const paramsTrim = (obj) => {
  if(typeof obj === 'string'){
    return trim(obj)
  }
  Object.keys(obj).forEach(key => {
    obj[key] = paramsTrim(obj[key])
  })
  return obj
}

// 容器号规则校验
export const verifyContainerNo = (inputValue) => {
  //exp：容器号 '000010C0000001025080969'、 10003028
  // 美国仓会存在00030、000020、000040开头的容器 00004000001010101000860\00001000001010101000009\
  const str = String(inputValue)
  const warehouseNo = Cookies.get('login.select.warehouse') || Cookies.get('warehouseNo')
  const startStr = '000010' + warehouseNo
  const startFlag = str.startsWith('000010') || str.startsWith('000020') || str.startsWith('000030') || str.startsWith('000040') || str.startsWith('000') || str.startsWith('1000')
  const midFlag = str.indexOf(warehouseNo) > -1
  const endFlag = str.slice(startStr.length) === 6
  const startFlagNew = str.startsWith('R') || str.startsWith('M') || str.startsWith('P') || str.startsWith('G') || str.startsWith('U') || str.startsWith('H') || str.startsWith('N') || str.includes('CB') || str.startsWith('A') || str.startsWith('F') || str.startsWith('Y')
  const containerNoFlag = startFlag || midFlag || endFlag || str.length >= 20 || startFlagNew
  if(containerNoFlag) {
    return true
  }
  return false
}

export const verifyContainerNoLength = (inputValue) => {
  const str = String(inputValue)
  if(str.length > 30){
    return true
  }
  return false
}

export const verifyOrderNo = (inputValue) => {
  const str = String(inputValue)
  const strLower = str && str.toLowerCase()
  const startFlag = strLower.startsWith('so') || strLower.startsWith('ro') || strLower.startsWith('rm') || strLower.startsWith('bc') || strLower.startsWith('tg') || strLower.startsWith('hd') || strLower.startsWith('rw') || strLower.startsWith('pw')
  if(startFlag){
    return true
  }
  return false
}

// 特殊符号校验并阻塞
export const verifySpecialSymbolsAndChoke = (inputValue) => {
  let str = String(inputValue)
  // 去掉tab符、回车符
  str = str.replace(/\t/g, '').replace(/[\s\n]/g, '')
  // 判断是否只包含字母、数字
  const regExp = /^[\w]+$/g
  return regExp.test(str)
}

// 特殊符号校验并替换
export const verifySpecialSymbols = (inputValue) => {
  let str = String(inputValue)
  // 去掉tab符、回车符
  str = str.replace(/\t/g, '').replace(/[\s\n]/g, '').replace(/\\t/g, '')

  return str
}

// 校验出库格口
export const verifyGridNo = (inputValue) => {
  let str = String(inputValue)
  // #20
  const startFlag = str.startsWith('#')
  const endNum = str.slice(1)
  const endFlag = endNum && _.isNaN(+endNum)

  if(startFlag && !endFlag){
    return true
  }
  return false
}

// 模糊校验
export const fuzzyVerify = (inputValue, scenes) => {
  if(!inputValue) return true;
  const str = String(inputValue)
  switch(scenes) {
    case 'orderNo':
      // 订单号校验，验证是否为容器号
      if(verifyContainerNo(str)){
        return true
      }
      break;
    case 'containerNo':
      // 容器号校验，验证不符合容器号规则
      if(!verifyContainerNo(str)){
        return true
      }
      break;
    case 'barcode':
      break;
    case 'count':
      break;
    case 'gridNo':
      if(verifyGridNo(str)){
        return true
      }
      break
    default:
      break;
  }
  
  return false
}

export const getPublicPath = () => {
  return  `${process.env.VUE_APP_OSS_PATH || '/'}${process.env.VUE_APP_OSS_ENV === 'file' ? '' : `iwms/main/${staticVersion}/`}`
}
// 获取静态文件路径，新加坡取common
export const getStaticPath = () => {
  return `${getPublicPath()}static/sound/`
}

/**
 * 获取 blob
 * url 目标文件地址
 */
const getBlob=(url)=> {
  return new Promise(resolve => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = () => {
          if (xhr.status === 200) {
              resolve(xhr.response);
          }
      };
      xhr.send();
  });
}

//下载文件
export const downloadFile = (url,fileName='download') => {
const link = document.createElement('a');
if(location.href.indexOf('https://') === 0){
  url= url.replace('http://', 'https://')
}else if(location.href.indexOf('http://') === 0){
  url= url.replace('https://', 'http://')
}
// 将链接地址字符内容转变成blob地址
 fetch(url)
  .then((res) => res.blob())
  .then((blob) => {
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
}

export function countUnique(items, key) {
  const uniqueSet = new Set();
  for (let item of items) {
    uniqueSet.add(item[key]);
  }
  return uniqueSet.size;
}

export function caseInsensitiveIncludes(arr, searchElement) {
  const searchStr = String(searchElement).toLowerCase();
  return arr.some(element => 
    String(element).toLowerCase() === searchStr
  );
}